import { DebugService } from './debug.service';
import { stratum } from '../../../constants/stratum.js';
import { AbTest, AbTestSchema } from '@cof/stratum';

export class _ExperimentService {
  _abTests: AbTestSchema;
  _experiments: string[];
  abTest: AbTest;
  debug: DebugService;
  constructor() {
    this.debug = new DebugService('ExperimentService');
    this._experiments = [];
    this._abTests = {
      name: 'lienholder-ab-tests',
      variationIds: [],
      testGroup: '',
      testWeight: '1',
    };
  }

  get experiments() {
    return this._experiments;
  }

  set experiments(experiments) {
    this._experiments = experiments;
  }

  updateExperiments(
    newExperiments: string[],
    removeExperiments: string[] = []
  ) {
    stratum.endAbTest(this.abTest);
    const newlyAddedExperiments = newExperiments.map((experiment: string) =>
      experiment.toLowerCase()
    );
    const updatedExperiments = this._experiments.filter(
      (experiment: string) => !removeExperiments.includes(experiment)
    );
    this._experiments = Array.from(
      new Set(updatedExperiments.concat(newlyAddedExperiments))
    );
    this._abTests.variationIds = this._experiments;
    this.abTest = stratum.startAbTest(this._abTests);
  }
}

export const ExperimentService = new _ExperimentService();
